import { Button } from '@velocity/ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EDevice } from '../../../redux/sequence/enums';
import { RootState } from '../../../redux/types';
import sequenceConfig from '../../../sequence/sequence-config';
import { Type } from '../../../types/instant-lease-api';
import Navigation from '../../../utils/navigation';
import SequencesPhases from '../../b2b/components/sequences-phases/sequences-phases';

const StatusPending: React.FC = () => {
  // Sequence config
  const config = sequenceConfig();

  // Sequence Store
  const { sequence, step, device } = useSelector(
    (state: RootState) => state.sequence,
  );

  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );

  // Navigate hook
  const navigate = useNavigate();

  // Navigation class
  const { nextRoute } = new Navigation();

  const isButtonDisabled = (): boolean => {
    return !activeApplication?.uuid;
  };

  const buttonLabel = config[sequence]?.overviewButtonLabel ?? 'weiter';

  return activeApplication ? (
    <section className='grid-container w-full bg-(--vel-color-neutral-100) pt-18 pb-12'>
      <div className='grid-layout'>
        <div className='col-span-4 md:col-span-4 md:col-start-2 lg:col-span-6 lg:col-start-4'>
          <SequencesPhases
            sequence={sequence}
            partner={activeApplication.partner}
            type={activeApplication.type || Type.B2B}
            config={config}
            step={step}
            action={
              <Button
                variant='secondary-filled'
                size={device === EDevice.DESKTOP ? 'l' : 'm'}
                type='button'
                onClick={() => navigate(nextRoute())}
                disabled={isButtonDisabled()}
                loading={!activeApplication?.uuid}
              >
                {buttonLabel}
              </Button>
            }
          />
        </div>
      </div>
    </section>
  ) : null;
};

export default StatusPending;
